import { useState } from "react"
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Input, Row } from "reactstrap"
import { categories, Sorter, sorters } from "../types"


export default function Filter(props: FilterPropsType) {

    const [filterDropdownOpen, openFilterDropdown] = useState(false)

    const toggleFilterDropdown = () => {
        openFilterDropdown(!filterDropdownOpen)
    }

    const [sortDropdownOpen, openSortDropdown] = useState(false)

    const toggleSortDropdown = () => {
        openSortDropdown(!sortDropdownOpen)
    }

    return (
        <Row className='justify-content-center align-items-center text-center'>
            <Col md={4}>
                <Dropdown id="filerSelect" isOpen={filterDropdownOpen} toggle={toggleFilterDropdown}>
                    <DropdownToggle caret>
                        Filtrar por:
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem href={'?c'}>Sin filtro</DropdownItem>
                        {categories.map(c => <DropdownItem key={c.id} href={'?c=' + c.id}>{c.name}</DropdownItem>)}
                    </DropdownMenu>
                </Dropdown>
            </Col>
            <Col md={4}>
                <Input placeholder="Buscar regalo" onChange={(v) => props.filteredName(v.target.value)} />
            </Col>
            <Col md={4}>
                <Dropdown id="sortSelect" isOpen={sortDropdownOpen} toggle={toggleSortDropdown}>
                    <DropdownToggle caret>
                        Ordenar por:
                    </DropdownToggle>
                    <DropdownMenu>
                        {sorters.map(s => <DropdownItem key={s.id} onClick={() => {props.sortBy(s);}}>{s.name}</DropdownItem>)}
                    </DropdownMenu>
                </Dropdown>
            </Col>
        </Row>
    )

}

export type FilterPropsType = {
    categoryName: string,
    sorter: Sorter,
    filteredName: (s: string) => void;
    sortBy: (s: Sorter) => void;
}